export default __webpack_public_path__ + "static/media/video.c0c50c98.svg";